module.exports = __webpack_public_path__ + "img/ask.c807892f.png";